import React, { useMemo, useState } from "react";

import Button from "@cayuse/shared-react.components.button";
import ButtonGroup from "@cayuse/shared-react.components.button-group";
import Radio from "@cayuse/shared-react.components.form.inputs.radio";
import Modal from "@cayuse/shared-react.components.modal";

import Dropdown from "components/Dropdown";
import { STATIC_BUDGET_CATEGORIES } from "globals/constants";
import { useDictionary } from "hooks";

import styles from "./styles.css";

const CostCategoryModal = ({ categories, onClose, isOpen, onAdd }) => {
	const dictionary = useDictionary("categories");
	const [ selectedCategory, setSelectedCategory ] = useState();
	const [ isNewParentCategory, setIsNewParentCategory ] = useState(true);

	const handleOptionChange = () => setIsNewParentCategory(!isNewParentCategory);

	const handleAdd = () => {
		onAdd(selectedCategory);
		reset();
	};

	const reset = () => {
		setIsNewParentCategory(true);
		setSelectedCategory(null);
	};

	const handleCancel = () => {
		onClose();
		reset();
	};

	const parentCategoryOptions = useMemo(
		() => categories
			.filter(category => !STATIC_BUDGET_CATEGORIES.includes(category?.value))
			.map(category => ({ value: category.hash, key: category.hash, text: category.value })),
		[ categories ]
	);

	return (
		<Modal closeIcon
			closeOnEscape={true}
			onClose={onClose}
			open={isOpen}
			ariaLabel={dictionary.modalHeader || "Add New"}
		>
			<Modal.Header className="whiteOnBlue">
				<h2>{dictionary.modalHeader || "Add New"}</h2>
			</Modal.Header>
			<Modal.Content className={styles.modalContent}>
				<Radio
					id={"newCategory"}
					onChange={() => handleOptionChange()}
					checked={isNewParentCategory}
				>
					{dictionary.addNewCategory || "Add a new category"}
				</Radio>
				<Radio
					id={"newLine"}
					onChange={() => handleOptionChange()}
					checked={!isNewParentCategory}
				>
					{dictionary.addNewLineItem || "Add new line item to an existing category"}
				</Radio>
				{!isNewParentCategory && (
					<Dropdown
						placeholder={dictionary.addNewLineItemPlaceholder || "Choose a category..."}
						selection
						options={parentCategoryOptions}
						onChange={(e, { value }) => setSelectedCategory(value)}
						value={selectedCategory}
					/>
				)}
			</Modal.Content>
			<Modal.Actions>
				<ButtonGroup>
					<Button secondary onClick={handleCancel}>
						{dictionary.cancel || "Cancel"}
					</Button>
					<Button primary onClick={handleAdd} disabled={!isNewParentCategory && !selectedCategory}>
						{dictionary.addCategory || "Add"}
					</Button>
				</ButtonGroup>
			</Modal.Actions>
		</Modal>
	);
};

export default CostCategoryModal;
